import React, { useRef, useEffect } from "react";
import { Bold, Italic, List, Link2, Heading } from "lucide-react";

export default function RichEditor({ value, onChange, testid = "rich-editor" }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
  }, [value]);

  const exec = (cmd, arg) => {
    document.execCommand(cmd, false, arg);
    ref.current?.focus();
    onChange(ref.current.innerHTML);
  };
  const makeLink = () => {
    const url = window.prompt("Link URL (use {{link}} for dynamic links)", "https://");
    if (url) exec("createLink", url);
  };

  const Btn = ({ icon: Icon, cmd, arg, tip, tid }) => (
    <button type="button" data-testid={tid} title={tip} onClick={() => (cmd === "link" ? makeLink() : exec(cmd, arg))}
      className="w-9 h-9 rounded-lg flex items-center justify-center text-primary/70 hover:bg-primary/10 transition-colors">
      <Icon size={16} />
    </button>
  );

  return (
    <div className="rounded-xl border border-primary/15 overflow-hidden">
      <div className="flex items-center gap-1 border-b border-primary/10 bg-muted/40 px-2 py-1.5">
        <Btn icon={Bold} cmd="bold" tip="Bold" tid={`${testid}-bold`} />
        <Btn icon={Italic} cmd="italic" tip="Italic" tid={`${testid}-italic`} />
        <Btn icon={Heading} cmd="formatBlock" arg="<h2>" tip="Heading" tid={`${testid}-h2`} />
        <Btn icon={List} cmd="insertUnorderedList" tip="Bulleted list" tid={`${testid}-list`} />
        <Btn icon={Link2} cmd="link" tip="Insert link" tid={`${testid}-link`} />
      </div>
      <div ref={ref} data-testid={testid} contentEditable suppressContentEditableWarning
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        className="min-h-[220px] p-4 text-sm leading-relaxed focus:outline-none prose-sm max-w-none [&_h2]:font-display [&_h2]:text-xl [&_h2]:font-semibold [&_a]:text-secondary [&_a]:underline [&_ul]:list-disc [&_ul]:pl-5" />
    </div>
  );
}
